import { c as _c } from "react/compiler-runtime";
import { Flex, Heading } from '@chakra-ui/react';
import { EventsKeywordSearchInput } from '@src/components/sco/Events/EventsKeywordSearchInput';
import React from 'react';
type EventsPageHeaderProps = {
  title: string;
  /** Hide the search field (e.g. nested embeds). Defaults to showing search. */
  showSearch?: boolean;
  searchPlaceholder?: string;
};

/**
 * Page title with keyword search opposite the heading.
 * Search writes to `?search=` and filters EventList / EventCalendar results.
 */
export const EventsPageHeader = props => {
  const $ = _c(10);
  const showSearch = props.showSearch !== false;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: "stretch",
      md: "center"
    };
    t1 = {
      base: "column",
      md: "row"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.title) {
    t2 = <Heading flexShrink={0} marginBottom={0}>{props.title}</Heading>;
    $[2] = props.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.searchPlaceholder || $[5] !== showSearch) {
    t3 = showSearch && <EventsKeywordSearchInput placeholder={props.searchPlaceholder || "Search events..."} />;
    $[4] = props.searchPlaceholder;
    $[5] = showSearch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <Flex align={t0} direction={t1} gap={4} justify="space-between" marginBottom="1em" width="full">{t2}{t3}</Flex>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};